import axiosInstance from '../../../helpers/axiosInstance';

export default {
  getAllBatchesOptions: (qs = '') => axiosInstance().get('batches', { params: qs }),
  getAllBatches: (qs = '') => axiosInstance().get('batches/pagination', { params: qs }),
  createBatch: (data) => axiosInstance().post('batches', data),
  editBatch: (id, data) => axiosInstance().put(`batches/${id}`, data),
};
